import { BuiltinInterface } from '../BuiltinInterface';
import { BuiltinValueObject } from '../BuiltinValueObject';
class FunctionInterface extends BuiltinInterface {
}
class FunctionValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'FunctionConstructor';
    }
}
class FunctionConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('Function', new FunctionInterface());
    builtins.addValue('Function', new FunctionValue());
    builtins.addInterface('FunctionConstructor', new FunctionConstructorInterface());
};

//# sourceMappingURL=index.js.map
